import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Colores principales */
    --blue: #007bff;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #dc3545;
    --orange: #fd7e14;
    --yellow: #ffc107;
    --green: #28a745;
    --teal: #20c997;
    --cyan: #17a2b8;
    --white: #fff;
    --gray: #6c757d;
    --gray-dark: #343a40;
    
    /* Colores temáticos adicionales */
    --color-01: #d60404;
    --color-02: #9e0101;
    --color-03: #FFBB00;
    --color-04: #d8ad51;
    
    /* Tipografías */
    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    
    /* Tamaños de fuente */
    --font-size-base: 1rem;
    --font-size-lg: 1.25rem;
    --font-size-sm: 0.875rem;
    --font-size-xs: 0.75rem;
    
    /* Espaciado */
    --spacing-1: 0.25rem;
    --spacing-2: 0.5rem;
    --spacing-3: 1rem;
    --spacing-4: 1.5rem;
    --spacing-5: 3rem;
    
    /* Bordes */
    --border-radius: 0.25rem;
    --border-radius-lg: 0.5rem;
    --border-radius-sm: 0.125rem;
    
    /* Sombras */
    --box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  }
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: var(--font-family-sans-serif);
    line-height: 1.5;
    color: var(--gray-dark);
    background-color: var(--white);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  a {
    color: var(--blue);
    text-decoration: none;
    transition: color 0.2s ease-in-out;
    
    &:hover {
      color: #0056b3;
      text-decoration: underline;
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  button, input, select, textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  
  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
  }
  
  h1 {
    font-size: 2.5rem;
  }
  
  h2 {
    font-size: 2rem;
  }
  
  h3 {
    font-size: 1.75rem;
  }
  
  h4 {
    font-size: 1.5rem;
  }
  
  h5 {
    font-size: 1.25rem;
  }
  
  h6 {
    font-size: 1rem;
  }
  
  p {
    margin-bottom: 1rem;
  }
  
  .container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    
    @media (min-width: 576px) {
      max-width: 540px;
    }
    
    @media (min-width: 768px) {
      max-width: 720px;
    }
    
    @media (min-width: 992px) {
      max-width: 960px;
    }
    
    @media (min-width: 1200px) {
      max-width: 1140px;
    }
  }

  /**
   * NOTA IMPORTANTE SOBRE DEGRADADOS:
   * 
   * Se ha estandarizado el uso de degradados en todo el proyecto:
   * - El degradado estándar para botones, fondos y elementos de acción va de #007bff a #0056b3:
   *   linear-gradient(135deg, #007bff 0%, #0056b3 100%)
   * 
   * - Para efectos de hover, NO usar degradados ni el color morado (--indigo). 
   *   En su lugar, usar un color sólido azul oscuro:
   *   background-color: #0056b3;
   * 
   * - Para contenedores de fondo claro se sigue usando:
   *   linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%)
   * 
   * - Para iconos y elementos de menor importancia:
   *   linear-gradient(135deg, #e9f5ff 0%, #dcebff 100%)
   * 
   * Esta estandarización garantiza consistencia visual en todo el sitio.
   */
`;

export default GlobalStyles; 